import { Injectable } from '@angular/core';
import { BudgetTypeEnum } from '@enums/BudgetType';
import { StructureDepthEnum } from '@enums/StructureDepth';
import { CategoryDetail } from '@interfaces/CategoryDetail';
import { DepartmentDetail } from '@interfaces/DepartmentDetail';
import { Estimate } from '@interfaces/Estimate';
import { EstimateLine } from '@interfaces/EstimateLine';
import { ImportedProjectStructureDto } from '@interfaces/ImportedProjectStructureDto';
import { Level1 } from '@interfaces/Level1';
import { Level1Detail } from '@interfaces/Level1Detail';
import { Structure } from '@interfaces/Structure';
import { EstimateService } from './estimate.service';

@Injectable({
  providedIn: 'root'
})
export class StructureService {
  public constructor(private estimateService: EstimateService) {}

  public getLevel2Detail(structure: Structure, rootEntity: Estimate) {
    const level2Detail = structure.level2Detail; // me
    if (level2Detail && rootEntity.structureDepth === StructureDepthEnum.Level2) {
      return level2Detail;
    }
    return null;
  }
  public getLevel1Detail(structure: Structure): Level1Detail {
    return structure.level1Detail;
  }

  public getLevel1DetailById(level1Id: string, rootEntity: Estimate | null): Level1Detail {
    return rootEntity?.structures.find(s => s.level1Detail && s.level1Id === level1Id)?.level1Detail || null;
  }

  public getLevel2DetailById(level2Id: string, rootEntity: Estimate | null): Level1Detail {
    return rootEntity?.structures.find(s => s.level2Detail && s.level2Id === level2Id)?.level2Detail || null;
  }

  public getParentDepartmentDetail(estimateLine: EstimateLine): DepartmentDetail {
    const estimateLines = estimateLine?.structure?.estimateLines || [];

    return (
      estimateLines.find(line => line.departmentEstimateId === estimateLine.departmentEstimateId)?.departmentDetail ||
      null
    );
  }

  public getDepartmentDetails(structure: Structure): DepartmentDetail[] {
    const estimateLines = structure.estimateLines || [];

    return estimateLines.map(line => line.departmentDetail) ?? [];
  }
  public getCategoryDetails(estimateLines: EstimateLine[], rootEntity: Estimate | null): CategoryDetail[] {
    if (rootEntity.budgetType === BudgetTypeEnum.Detailed) {
      return []; // no category details in this case. I suppose..
    }
    return estimateLines?.map(line => line.categoryDetail) ?? [];
  }

  public createLevel1(projectStructure: ImportedProjectStructureDto) {
    const estimate = this.estimateService.currentEstimate;

    const level1ModelCode = projectStructure.level1Code;

    let newLevel1Code = level1ModelCode;

    let count = 1;
    while (estimate.structures.find(s => s.level1.code === newLevel1Code)) {
      newLevel1Code = `${level1ModelCode}_${count++}`;
    }

    return this.estimateService.createLevel1({
      code: newLevel1Code,
      description: projectStructure.level1Desc,
      level1ModelCode: level1ModelCode
    });
    //Add to structures
  }

  public createLevel2(projectStructure: ImportedProjectStructureDto, level1: Level1) {
    const estimate = this.estimateService.currentEstimate;

    const level2ModelCode = projectStructure.level2Code;

    let newLevel2Code = level2ModelCode;

    let count = 1;
    while (estimate.structures.find(s => s.level1.id === level1.id && s.level2?.code === newLevel2Code)) {
      newLevel2Code = `${level2ModelCode}_${count++}`;
    }

    return this.estimateService.createLevel2({
      code: newLevel2Code,
      description: projectStructure.level2Desc,
      level2ModelCode: level2ModelCode
    });
  }
}
